import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import sortLogic from './sort';
import selectionLogic from './selection';
var middlewares = [].concat(_toConsumableArray(sortLogic), _toConsumableArray(selectionLogic));
export default middlewares;